import React from 'react';
import { TabF, TabsF } from 'components/tabs/tabfile';

const PayslipManagementSubNav = () => {
  return (
    <TabsF>
      <TabF label={'payslips'} tabName={'Fiches de paie'} />
      <TabF label={'invoices'} tabName={'Factures client'} />
    </TabsF>
  );
};

export default PayslipManagementSubNav;
